var _defs, _path, _line, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduledExerciseInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.71 58.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .scheduled-exercise-invite {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "scheduled-exercise-invite",
    d: "m12.87,29.07v-14.57c0-4.2,3.4-7.6,7.6-7.6h32.64c4.2,0,7.6,3.4,7.6,7.6v26.62c0,4.2-3.4,7.6-7.6,7.6h-18.02"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "scheduled-exercise-invite",
    x1: 12.87,
    y1: 18.37,
    x2: 60.71,
    y2: 18.37
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "scheduled-exercise-invite",
    x1: 31.3,
    y1: 11.78,
    x2: 31.3,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "scheduled-exercise-invite",
    x1: 20.33,
    y1: 11.78,
    x2: 20.33,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "scheduled-exercise-invite",
    x1: 42.28,
    y1: 11.78,
    x2: 42.28,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "scheduled-exercise-invite",
    x1: 53.25,
    y1: 11.78,
    x2: 53.25,
    y2: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "scheduled-exercise-invite",
    d: "m26.84,52.03c-.91,4.3-6.13,5.96-9.32,2.96l-2.08-1.95c-.55-.52-1.27-.81-2.03-.82l-3.99-.05c-1.61-.02-2.92-1.32-2.97-2.94l-.13-4.23c-.02-.8-.36-1.55-.93-2.11l-1.67-1.61c-3.26-3.16-1.67-8.7,2.76-9.62l21.82-4.52c1.87-.39,3.52,1.29,3.13,3.17l-4.6,21.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "scheduled-exercise-invite",
    d: "m26.84,52.03c-.91,4.3-6.13,5.96-9.32,2.96l-2.08-1.95c-.55-.52-1.27-.81-2.03-.82l-3.99-.05c-1.61-.02-2.92-1.32-2.97-2.94l-.13-4.23c-.02-.8-.36-1.55-.93-2.11l-1.67-1.61c-3.26-3.16-1.67-8.7,2.76-9.62l21.82-4.52c1.87-.39,3.52,1.29,3.13,3.17l-4.6,21.72Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "scheduled-exercise-invite",
    x1: 30.73,
    y1: 27.88,
    x2: 7.36,
    y2: 51.33
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduledExerciseInvite);
export default __webpack_public_path__ + "static/media/scheduled-exercise-invite.399a2b1d.svg";
export { ForwardRef as ReactComponent };